import type { ApiResponse, PaginationQuery, ArtistDto, AlbumDto, SongDto } from '@lyricshub/shared';
import { api } from './api';

export const artistsService = {
  async getArtists(params?: PaginationQuery): Promise<ApiResponse<ArtistDto[]>> {
    const response = await api.get('/artists', { params });
    return response.data;
  },

  async getFeatured(): Promise<ApiResponse<ArtistDto[]>> {
    const response = await api.get('/artists/featured');
    return response.data;
  },

  async getArtistBySlug(slug: string): Promise<ApiResponse<ArtistDto>> {
    const response = await api.get(`/artists/${slug}`);
    return response.data;
  },

  async getArtistSongs(slug: string, params?: PaginationQuery): Promise<ApiResponse<SongDto[]>> {
    const response = await api.get(`/artists/${slug}/songs`, { params });
    return response.data;
  },

  async getArtistAlbums(slug: string): Promise<ApiResponse<AlbumDto[]>> {
    const response = await api.get(`/artists/${slug}/albums`);
    return response.data;
  },
};
